export default (length = 2) => {
  let code = Math.floor(Math.random() * Math.pow(10, length)) + ''
  while (code.length < length) code = '0' + code
  return code
}



// WEBPACK FOOTER //
// ./src/utils/random_code.js